import React from "react";
import { Icon } from "@iconify/react";

const DeleteIcon = ({ onClick, className = "", ...props }) => {
  return (
    <span
      onClick={onClick}
      className={className}
      style={{
        cursor: onClick ? "pointer" : undefined,
        color: "#888", // default icon color
        transition: "color 0.2s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.color = "#e53935")} // red on hover
      onMouseLeave={(e) => (e.currentTarget.style.color = "#888")}
      {...props}
    >
      <Icon icon="mdi:delete" />
    </span>
  );
};

export default DeleteIcon;
